import request from '@/utils/request'
export function pageBatterylist(params) {
  return request({
    url: '/v3/manager/deviceBattery/pageBatterylist?key=' + params.key + '&pageNum=' + params.pageNum + '&size=' + params.pageSize,
    method: 'get',
    data: params
  })
}
export function add(params) {
  return request({
    url: '/v3/manager/deviceBattery/add',
    method: 'post',
    data: params
  })
}
export function update(params) {
  return request({
    url: '/v3/manager/deviceBattery/update',
    method: 'post',
    data: params
  })
}
// 分页曲线
export function pageCurveNumberInfo(params) {
  return request({
    url: '/v3/manager/curveNumberInfo/pageCurveNumberInfo',
    method: 'post',
    data: params
  })
}
// 曲线详情
export function getCurveNumberInfoById(params) {
  return request({
    url: '/v3/manager/curveNumberInfo/getCurveNumberInfoById?id=' + params.id,
    method: 'get',
    data: params
  })
}
// 曲线删除
export function deleteCurve(id) {
  return request({
    url: '/v3/manager/curveNumberInfo/deleteCurve?id=' + id,
    method: 'get',
    data: {}
  })
}
// 新增曲线--提交
export function addCurveNumberInfo(params) {
  return request({
    url: '/v3/manager/curveNumberInfo/addCurveNumberInfo',
    method: 'post',
    data: params
  })
}
// 编辑曲线--提交
export function updateCurveNumberInfo(params) {
  return request({
    url: '/v3/manager/curveNumberInfo/updateCurveNumberInfo',
    method: 'post',
    data: params
  })
}

export function reloadCascadeCache() {
  return request({
    url: '/v3/manager/deviceBattery/reloadCascadeCache',
    method: 'post',
    data: {}
  })
}
